import React from 'react';
import { Action, withInject } from '@piwikpro/platform';
import {
  Text,
  Stack,
  withTranslation,
  TFunction,
} from '@piwikpro/ui-components';
import { FormikActions } from 'formik';
import { Apps, App } from '@piwikpro/apps-crate';

export interface RealTimeDashboardsProps {
  apps: Apps
  app: App
  t: TFunction
}

interface FormValues {
  realTimeDashboards: boolean
}

class RealTimeDashboards extends React.Component<RealTimeDashboardsProps, null> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(
    values: FormValues,
    { setFieldValue, setSubmitting }: FormikActions<FormValues>,
  ) {
    const { apps, app } = this.props;

    try {
      await apps.update(app.id, values);
    } catch (err) {
      setFieldValue('realTimeDashboards', !values.realTimeDashboards, false);
    }

    setSubmitting(false);
  }

  render() {
    const {
      app,
      t,
    } = this.props;

    return (
      <Stack wrap verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.real-time-dashboards.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.real-time-dashboards.description')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Action.AutoSavedSwitcherControl
            id="app-settings-real-time-dashboards-integration"
            initialValue={app.attributes.realTimeDashboards}
            name="realTimeDashboards"
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default withInject({
  apps: 'AppsCrate.apps',
})(
  withTranslation(['administration'])(RealTimeDashboards as any),
);
